const defaultPagination = {
  next: 1,
  previous: null,
  count: null,
};

export function getPaginationDetails(state, key) {
  return state.pagination[key] || defaultPagination;
}



// WEBPACK FOOTER //
// ./src/selectors/paginationSelectors.js